import { render, staticRenderFns } from "./categoryNameDialog.vue?vue&type=template&id=7382bcc6"
import script from "./categoryNameDialog.vue?vue&type=script&lang=js"
export * from "./categoryNameDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2585860866/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7382bcc6')) {
      api.createRecord('7382bcc6', component.options)
    } else {
      api.reload('7382bcc6', component.options)
    }
    module.hot.accept("./categoryNameDialog.vue?vue&type=template&id=7382bcc6", function () {
      api.rerender('7382bcc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/menu/editor/categoryNameDialog.vue"
export default component.exports